export enum BwjValidityState {
    ValidationError,
    Warning,
    Indeterminate,
    Invalid,
    Valid
}
